// @ts-nocheck 30f5692b
import * as utils from '@wix/santa-editor-utils';

const { editorSessionId } = utils.editorModel;

export { editorSessionId };
